<!-- 获取交易记录 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "billType": 0,
                "billCode": "20171015000000",
                "transactionCode": "20171015141333"
            },
            responseCode: 	{
                "data": {
                    "billCode": "20220821404000001",
                    "billType": 0,
                    "billValue": 0.01,
                    "carCode": "津A12345",
                    "carNo": "津A12345",
                    "parkCode": "2KKN6332",
                    "payTime": "20220826181423",
                    "recordList": [],
                    "topBillCode": "2235526181230088920287345",
                    "transactionCode": "E55522082618140600013712"
                },
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            },infoData: {
                explain: "第三方接入系统请求智慧停车开放平台查询智慧停车用户交易记录",
                t_url: this.commonUrls.test+"queryTransactionRecord",
                p_url: this.commonUrls.prod+"queryTransactionRecord",
                precondition: "无",
                fitSystem: "传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'billCode', info2: '否', info3: 'String', info4: '订单号(billCode,transactionCode 二选一，优先transactionCode)' },
                        { info1: 'transactionCode', info2: '否', info3: 'String', info4: '交易订单号(billCode,transactionCode 二选一，优先transactionCode)' },
                        { info1: 'billType', info2: '否', info3: 'Integer', info4: '订单类型，默认0或7，<url>参考附录:/Api/appendixData#appendixData_6</url>' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'topBillCode', info2: '是', info3: 'String', info4: '顶级记录编号' },
                        { info1: 'billCode', info2: '是', info3: 'String', info4: '订单号' },
                        { info1: 'transactionCode', info2: '是', info3: 'String', info4: '交易订单号' },
                        { info1: 'payTime', info2: '是', info3: 'String', info4: '支付时间，格式：yyyyMMddHHmmss' },
                        { info1: 'payMoney', info2: '是', info3: 'Decimal', info4: '支付金额' },
                        { info1: 'billType', info2: '否', info3: 'Integer', info4: '订单类型，<url>参考附录:/Api/appendixData#appendixData_6</url>' },
                        { info1: 'carNo', info2: '否', info3: 'String', info4: '车牌号码' },
                        { info1: 'recordList', info2: '否', info3: 'JSONArray', info4: '记录列表' },
                        { info1: 'startTime', info2: '是', info3: 'String', info4: '开始时间，格式：yyyyMMddHHmmss' },
                        { info1: 'endTime', info2: '是', info3: 'String', info4: '结束时间，格式：yyyyMMddHHmmss' },
                        ]
                },{
                    titleName: 'recordList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'topBillCode', info2: '是', info3: 'String', info4: '顶级记录编号' },
                        { info1: 'billCode', info2: '是', info3: 'String', info4: '订单号' },
                        { info1: 'transactionCode', info2: '是', info3: 'String', info4: '交易订单号' },
                        { info1: 'payTime', info2: '是', info3: 'String', info4: '支付时间，格式：yyyyMMddHHmmss' },
                        { info1: 'payMoney', info2: '是', info3: 'Decimal', info4: '支付金额' },
                        { info1: 'billType', info2: '否', info3: 'Integer', info4: '订单类型，<url>参考附录:/Api/appendixData#appendixData_6</url>' },
                        { info1: 'carNo', info2: '否', info3: 'String', info4: '车牌号码' },
                        { info1: 'startTime', info2: '是', info3: 'String', info4: '开始时间，格式：yyyyMMddHHmmss' },
                        { info1: 'endTime', info2: '是', info3: 'String', info4: '结束时间，格式：yyyyMMddHHmmss' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/parking/bill/queryTransactionRecord.vue